var map = {
	"./icon-status-achieved.png": "da43",
	"./icon-status-all.png": "750d",
	"./icon-status-awarded.png": "0492",
	"./icon-status-denied.png": "536f",
	"./icon-status-in-progress-assessor.png": "7667",
	"./icon-status-in-progress-issuer.png": "8d36",
	"./icon-status-not-submitted.png": "2e6f",
	"./icon-status-review-pending.png": "c213"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7348";